export const SET_USER = 'SET_USER';
export const SET_ERRORS = 'SET_ERRORS';
export const SET_ROLES = 'SET_ROLES';
